import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  FRENCH_DEPARTMENTS_MAP,
  FRENCH_REGIONS,
  FrenchDepartment,
  FrenchRegion,
  InterventionZoneDto,
} from '@workspace/data-types';

@Component({
  selector: 'etxe-agent-zones-display',
  imports: [MatIconModule],
  templateUrl: './agent-zones-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentZonesDisplayComponent {
  readonly primaryRegion = input<FrenchRegion | undefined>(undefined);
  readonly interventionZones = input<InterventionZoneDto[] | undefined>(undefined);

  readonly availableRegions = FRENCH_REGIONS;

  getRegionName(reg?: FrenchRegion): string {
    if (!reg) return '';
    const r = this.availableRegions.find((x) => x.code === reg);
    return r ? r.name : reg;
  }

  getDepartmentsByRegion(departments?: string[]): Array<{
    regionName: string;
    isPrimary: boolean;
    departments: Array<{ code: string; name: string }>;
  }> {
    if (!departments || departments.length === 0) return [];
    const primaryRegion = this.primaryRegion();
    const primaryRegionName = this.getRegionName(primaryRegion);

    const map = new Map<string, Array<{ code: string; name: string }>>();

    for (const d of departments) {
      const info = FRENCH_DEPARTMENTS_MAP[d as FrenchDepartment];
      const regionCode = info?.region;
      const regionObj = this.availableRegions.find((r) => r.code === regionCode);
      const regName = regionObj ? regionObj.name : 'Autres départements';

      let list = map.get(regName);
      if (!list) {
        list = [];
        map.set(regName, list);
      }
      list.push({
        code: info ? info.code : d,
        name: info ? info.name : d,
      });
    }

    const result: Array<{
      regionName: string;
      isPrimary: boolean;
      departments: Array<{ code: string; name: string }>;
    }> = [];

    map.forEach((depts, regName) => {
      result.push({
        regionName: regName,
        isPrimary: regName === primaryRegionName,
        departments: depts.sort((a, b) => a.code.localeCompare(b.code)),
      });
    });

    return result.sort((a, b) => {
      if (a.isPrimary) return -1;
      if (b.isPrimary) return 1;
      return a.regionName.localeCompare(b.regionName);
    });
  }
}
